import { z } from "zod";

export const preOsSchema = z.object({
  osPrincipal: z.string().nonempty("Informe o ticket problem"),
  descricao: z.string().nonempty("Descrição obrigatória"),
  assunto: z.string().nonempty("Informe o assunto"),
  codigoPosto: z.string().optional(),
  serial: z.string().optional(),
  numeroSerie: z.string().nonempty("Informe o número de série"),
  statusSolicitacao: z.enum(["aguardando_os", "gerado_os", "erro"], {
    error: "Selecione um status da solicitação",
  }),
  nomeConsumidor: z.string().nonempty("Informe o nome do consumidor"),
  emailConsumidor: z.string().nonempty("Informe o e-mail do consumidor"),
  cep: z.string().nonempty("Informe o CEP"),
  endereco_2: z.string().nonempty("Informe o endereço"),
  numero: z.string().optional(),
  bairro: z.string().nonempty("Informe o bairro"),
  cidade: z.string().nonempty("Informe a cidade"),
  estado: z.string().nonempty("Informe o estado"),
  telefoneConsumidor: z.string().nonempty("Informe o telefone do consumidor"),
  notaFiscal: z.string().nonempty("Informe a nota fiscal"),
  anexos: z.array(z.instanceof(File)).optional(),
  dataCompra: z.string().nonempty("Informe a data de compra"),
  defeitoReclamado: z.string().nonempty("Informe o defeito reclamado"),
  aparenciaProduto: z.string().optional(),
  referenciaProduto: z.string().nonempty("Informe o código do produto."),
  descricaoProduto: z.string().nonempty("Informe a descrição do produto."),
  cpf: z.string().nonempty("Informe o CPF do consumidor"),
});

export type IncidentProps = z.infer<typeof preOsSchema>;
